var exports = {
  "k": "MessageCharacterCounter.module__container___R1hhRj",
};

module.exports = exports;
